import type { ChangeEventHandler } from 'react';
import { memo } from 'react';
import styles from './style/FilePicker.module.css';

type Props = {
  accept?: string;
  className?: string;
  multiple?: boolean;
  onSelect: ChangeEventHandler<HTMLInputElement>;
  'aria-label'?: string;
};

export const FilePicker = memo(({
  accept = 'image/jpeg,image/png',
  className,
  multiple = false,
  onSelect,
  'aria-label': ariaLabel = 'Choose image file',
}: Props) => {
  return (
    <div className={className}>
      <div className={styles.input}>
        <input
          type='file'
          accept={accept}
          multiple={multiple}
          onChange={onSelect}
          aria-label={ariaLabel} />
        <span className={styles.span}>Choose File</span>
      </div>
    </div>
  );
});

FilePicker.displayName = 'FilePicker';
